import React from 'react'
import { connect } from 'react-redux'
import PropType from 'prop-types'
import Container from '../../components/Container/Container'
import Button from '../../components/Button/Button'
import './Confirmation.scss'
import { tagConfirmationPage } from '../../helpers/tag/dynamicPageview'
import routes from '../../config/routes'
import history from '../../config/history'
import { resetFlow } from '../../actions/reset'

class Confirmation extends React.Component {
  componentDidMount() {
    window.onpopstate = this.onBackButtonEvent
    tagConfirmationPage()
  }

  componentWillUnmount() {
    window.onpopstate = null
  }

  onBackButtonEvent = e => {
    const routes = [
      'flight-offers',
      'ancillaries',
      'booker-details',
      'group-details',
      'summary',
    ]
    const nextRoute = e.target.location.path
    for (const route in routes) {
      if (nextRoute.includes(routes[route])) {
        this.startNewSearch()
        break
      }
    }
  }

  startNewSearch = () => {
    this.props.resetFlow()
    history.push(routes.rootPath)
  }

  render() {
    const labels = this.props.content('Confirmation')
    const { email } = this.props
    return (
      <Container>
        <h1>{labels['Heading']}</h1>
        <p>{labels['Description'].replace('{email}', email)}</p>
        <div className="Confirmation__nextsteps">
          <h3>{labels['Sub Heading']}</h3>
          <ol className="Confirmation__nextsteps-list">
            <li>{labels['Sub Description 1']}</li>
            <li>{labels['Sub Description 2']}</li>
            <li>{labels['Sub Description 3']}</li>
          </ol>
        </div>
        <Button align="right" onClick={this.startNewSearch}>
          {labels['New Search Button Label']}
        </Button>
      </Container>
    )
  }
}

Confirmation.propTypes = {
  history: PropType.object,
  email: PropType.string,
  content: PropType.func,
  resetFlow: PropType.func,
}

const mapStateToProps = state => {
  const { bookerDetails } = state
  return {
    email: bookerDetails.emailAddress,
  }
}

const mapDispatchToProps = {
  resetFlow,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Confirmation)
